import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, IconButton, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import strings from 'common/Translation/Translate';

export type EInvoiceErrorsCardProps = {
  title: string;
  errors: string[];
  onDismiss?: () => void;
};

export const EInvoiceErrorsCard = ({ title, errors, onDismiss }: EInvoiceErrorsCardProps) => {
  if (!errors.length) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 2,
        mb: 1,
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'error.light',
        bgcolor: theme => (theme.palette.mode === 'dark' ? 'rgba(211, 47, 47, 0.12)' : 'rgba(211, 47, 47, 0.06)'),
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
          px: 2,
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'error.light',
        }}>
        <ErrorOutlineOutlinedIcon color="error" sx={{ mt: 0.25, flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" color="error.main" fontWeight={700}>
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {strings.eInvoiceErrorsCardHint}
          </Typography>
        </Box>
        {onDismiss && (
          <IconButton size="small" aria-label={strings.eInvoiceErrorsDismiss} onClick={onDismiss} sx={{ mt: -0.5 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <List dense disablePadding sx={{ py: 0.5, pl: 2.5 }}>
        {errors.map((error, index) => (
          <ListItem
            key={`${index}-${error.slice(0, 40)}`}
            sx={{ py: 0.25, px: 2, display: 'list-item', listStyleType: 'disc' }}>
            <ListItemText
              primary={error}
              primaryTypographyProps={{
                variant: 'body2',
                color: 'text.primary',
                sx: { wordBreak: 'break-word' },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};
